/*
  HAPPE BOX V3 - Storage Wrapper Service Module (theme-storage.js)
*/

class HappeStorageManager {
  setLocal(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.warn('[Happe Storage] Fail write localStorage', e);
    }
  }

  getLocal(key) {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch (e) {
      return null;
    }
  }

  removeLocal(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {}
  }
}

window.HappeStorageClass = HappeStorageManager;
